import { render, staticRenderFns } from "./pagination-mini.vue?vue&type=template&id=13376e58&scoped=true&"
import script from "./pagination-mini.vue?vue&type=script&lang=js&"
export * from "./pagination-mini.vue?vue&type=script&lang=js&"
import style0 from "./pagination-mini.vue?vue&type=style&index=0&id=13376e58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13376e58",
  null
  
)

export default component.exports